import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

import { CLEAR_CONTENT, SET_TABLE, SET_IS_SHOW_KNOB, SET_IS_SIDE_BAR_DRAWER_OPEN } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const clearContent = buildActionObject('clearContent');
export const setTableContent = buildActionObject('setTableContent');
export const setIsShowKnob = buildActionObject('setIsShowKnob');
export const setIsSideBarDrawerOpen = buildActionObject('setIsSideBarDrawerOpen');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[clearContent.action]({ commit }) {
		commit(CLEAR_CONTENT);
	},
	[setTableContent.action]({ commit }, payload) {
		commit(SET_TABLE, payload);
	},
	[setIsShowKnob.action]({ commit }, payload) {
		commit(SET_IS_SHOW_KNOB, payload);
		if (!payload) {
			commit(SET_IS_SIDE_BAR_DRAWER_OPEN, false);
		}
	},
	[setIsSideBarDrawerOpen.action]({ commit }, payload) {
		commit(SET_IS_SIDE_BAR_DRAWER_OPEN, payload);
	},
};

export default actions;
